// https://vuex.vuejs.org/en/mutations.html

export default {
  refreshResellers(state, resellers) {
    state.list = resellers;
  },
  updateReseller (state, reseller) {
    var existingElementIndex
    state.list.some((el, index) => {
      if (el.uid === reseller.uid) {
        existingElementIndex = index
        return true
      }
    })
    if (existingElementIndex > -1) {
      state.list.splice(existingElementIndex, 1, reseller)
    } else {
      state.list.push(reseller)
    }
  },
};
